import React from 'react';

import { Card, Col, Row } from 'antd';
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

import { AgroReportDaily } from '../../../models/AgroReport';

interface Props {
    daily: AgroReportDaily[];
}

export default function ChartsBlock(props: Props) {
    if (!props.daily || props.daily.length === 0) {
        return null;
    }

    const data = props.daily.map((d) => ({
        date: d.date,
        avg: d.avg_temp,
        min: d.min_temp,
        max: d.max_temp,
        precip: d.precip,
        sat: d.sat,
    }));

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col xs={24} lg={12}>
                <Card title="Температура воздуха, °C">
                    <ResponsiveContainer width="100%" height={280}>
                        <LineChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" fontSize={11} />
                            <YAxis fontSize={11} />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="min" stroke="#1E88E5" name="Мин" dot={false} />
                            <Line type="monotone" dataKey="avg" stroke="#43A047" name="Средняя" dot={false} />
                            <Line type="monotone" dataKey="max" stroke="#E53935" name="Макс" dot={false} />
                        </LineChart>
                    </ResponsiveContainer>
                </Card>
            </Col>
            <Col xs={24} lg={12}>
                <Card title="Осадки и СЭТ">
                    <ResponsiveContainer width="100%" height={280}>
                        <LineChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" fontSize={11} />
                            <YAxis yAxisId="left" fontSize={11} />
                            <YAxis yAxisId="right" orientation="right" fontSize={11} />
                            <Tooltip />
                            <Legend />
                            <Line yAxisId="left" type="monotone" dataKey="precip" stroke="#1976D2" name="Осадки, мм" dot={false} />
                            <Line yAxisId="right" type="monotone" dataKey="sat" stroke="#F57C00" name="СЭТ, °C·дн" dot={false} />
                        </LineChart>
                    </ResponsiveContainer>
                </Card>
            </Col>
        </Row>
    );
}
